var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSla = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#EB5757"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.855 16.268 6.277-10.984a1 1 0 0 1 1.736 0l6.277 10.985a1 1 0 0 1-.868 1.496H5.723a1 1 0 0 1-.868-1.497Z",
  stroke: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.384 8.765h1.232v4.93h-1.232zM11.384 14.927h1.232v1.232h-1.232z"
})));
export default SvgSla;